import React, { useCallback } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { TeamsIcon } from '@atlaskit/logo';
import {
	LinkMenuItem,
	type LinkMenuItemProps,
} from '@atlaskit/navigation-system/side-nav-items/link-menu-item';
import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import { useNavigateToTeamsApp } from '@confluence/teams-app-config/entry-points/useNavigateToTeamsApp.ts';

const i18n = defineMessages({
	TeamsAppShortcutName: {
		id: 'side-navigation.custom.teams-app-shortcut.name',
		description: 'name to custom teams app shortcut link',
		defaultMessage: 'Teams',
	},
});

const elemBefore: LinkMenuItemProps['elemBefore'] = (
	<TeamsIcon size="xsmall" shouldUseNewLogoDesign />
);
const elemAfter: LinkMenuItemProps['elemAfter'] = (
	<LinkExternalIcon label="" spacing="spacious" size="small" />
);

export function TeamsAppShortcutItem() {
	const { href } = useNavigateToTeamsApp({
		type: 'LANDING',
	});
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireClickAnalyticsEvent = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'teamsAppShortcut',
				source: 'globalNavigation',
			},
		}).fire();
	}, [createAnalyticsEvent]);

	return (
		<LinkMenuItem
			elemAfter={elemAfter}
			elemBefore={elemBefore}
			href={href}
			target="_blank"
			onClick={fireClickAnalyticsEvent}
		>
			<FormattedMessage {...i18n.TeamsAppShortcutName} />
		</LinkMenuItem>
	);
}
